










import Vue from 'vue';
import { LightStatus } from '@/store';
import ActionButton from '@/components/common/ActionButton.vue';
import DeviceType from '@/enums/DeviceType';
export default Vue.extend({
  name: 'ErrorConnectingToWiFi',
  components: {
    ActionButton,
  },
  computed: {
    subtitle(): string {
      const status = this.$store.state.lightStatus;
      switch (status) {
        case LightStatus.WrongPassword:
        case LightStatus.APNotFound:
          return Vue.i18n.translate('WiFi_Credentials_Invalid') || '';
        case LightStatus.ConnectionFailed:
          switch (this.$store.state.deviceType) {
            case DeviceType.Light:
              return Vue.i18n.translate('WiFi_Connection_Failed_Light') || '';
            case DeviceType.Plug:
              return Vue.i18n.translate('WiFi_Connection_Failed_Plug') || '';
            case DeviceType.WiFiSwitch:
              return (
                Vue.i18n.translate('WiFi_Connection_Failed_WiFi_Switch') || ''
              );
          }
      }
      return Vue.i18n.translate('WiFi_Connection_Failed_Light') || '';
    },
  },
  methods: {
    tryAgain() {
      this.$store.commit('cleanStateToEnterPassword');
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ErrorConnectingToWiFi.vue